var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgI3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1582",
    "data-name": "Group 1582",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.125,
    height: 24.147,
    viewBox: "0 0 24.125 24.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_658",
    "data-name": "Rectangle 658",
    width: 24.125,
    height: 24.147,
    fill: "#eaeaea"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1581",
    "data-name": "Group 1581",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M43.067,12.112c0,2.317,0,4.633,0,6.95a4.839,4.839,0,0,1-5.078,5.081q-5.763.008-11.526,0a4.819,4.819,0,0,1-5.094-5.109c0-.659-.006-1.318,0-1.978a1.209,1.209,0,1,1,2.4-.018c.008.734-.006,1.469,0,2.2a2.37,2.37,0,0,0,2.453,2.468q5.989.021,11.978,0a2.331,2.331,0,0,0,2.426-2.427q.02-7.2,0-14.408A2.332,2.332,0,0,0,38.2,2.452q-5.989-.022-11.978,0a2.37,2.37,0,0,0-2.448,2.473c-.009.734,0,1.469,0,2.2a1.219,1.219,0,0,1-1.217,1.334A1.2,1.2,0,0,1,21.37,7.157q-.017-1.158,0-2.317A4.764,4.764,0,0,1,26.128.031Q32.2-.032,38.276.03a4.786,4.786,0,0,1,4.787,4.906c.019,2.392,0,4.784,0,7.176",
    transform: "translate(-18.947 0)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M11.444,67.675c-.451-.444-.908-.88-1.35-1.333a1.22,1.22,0,0,1-.078-1.8,1.19,1.19,0,0,1,1.76.082q1.749,1.724,3.473,3.473a1.186,1.186,0,0,1,0,1.841q-1.723,1.75-3.473,3.473a1.19,1.19,0,0,1-1.76.086,1.218,1.218,0,0,1,.074-1.8c.442-.453.9-.89,1.482-1.463h-.764q-4.686,0-9.371,0c-.905,0-1.492-.542-1.433-1.295A1.26,1.26,0,0,1,1.434,67.8q3.613-.007,7.226,0h2.706l.078-.127",
    transform: "translate(-0.001 -56.936)",
    fill: "#eaeaea"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI3);
export default __webpack_public_path__ + "static/media/i3.9bba33e41594a9292b6c483c2cc86db0.svg";
export { ForwardRef as ReactComponent };